<div class="prompt-container">
    <p>Please rotate your device.</p>
</div>
